import React, { useEffect, useState } from 'react';
import api from '../../_services/api'
import api_direct from '../../_services/api_direct'
import {useParams} from 'react-router-dom'
import { Title,Content,NumPedido,ProductItem,SubProductItem,ItemInformation,Footer,Line} from './styles';
import {Row, Container, Col, Button, Modal } from 'react-bootstrap'
import TextField from '@mui/material/TextField';
import { Formik, Field, ErrorMessage, Form as FormFormik  } from 'formik';
import Form from 'react-bootstrap/Form';
import IconButton from '@mui/material/IconButton'
import { AiOutlineCamera,AiFillInfoCircle } from 'react-icons/ai';
import { LoaderSmall } from "../../components/Loader";
import notify from '../../components/UI/toast'
import {HiOutlineChevronDown} from 'react-icons/hi'

import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'

import { useUserData } from "../../hooks/UserContext";

export default function HelpYou() {
    const [show, setShow] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [options, setOptions] = useState([]);
    const [items, setItems] = useState([]);
    const [file, setFile] = useState(null);

    const {uuid} = useParams()
    const [Loading, setLoading] = useState(false)

    const jwt = useUserData()
    const dataUser = jwt?.userData?.data
    let customerUuid = dataUser?.uuid

    const getFirstNumbersOrder = (orderUuid) => {
        return orderUuid.substring(0, 8).toUpperCase();
    }

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSelect = (e) => {
        setSelectedOption(e.target.value);
        handleShow();
    };

    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
      }

    const  getListTicketOptions = async () => {
        const response = await api.get(`/api/support-list-ticket-types`)
        const {available_ticket_types} = response.data
        let results = []
        let index = 0
        for(let ticket in available_ticket_types) {
            results[index] = {
              id: index + 1,
              key: ticket,
              label: available_ticket_types[ticket],
            };
            index++;
        }
        setOptions(results)
    }

    const getOrderItens = async () => {
        if(customerUuid){
            const response = await api.get(`/api/list-customer-orders?customerUuid=${customerUuid}&orderUuid=${uuid}`)
            let result = []
            const orders = response?.data?.data || [] 
            for(let i = 0; i < orders.length; i++){
                const order = orders[i]
                for(let i = 0; i < order.items.length; i++){
                    const item = order.items[i]
                    console.log(item)
                    result.push(
                        {
                            'uuid': item.uuidProduct, 
                            'brandName': item.brandName,
                            'product': item.product,
                        })
                }
            }
            setItems(result)
        }
    }

    const handleSupportOpenTicket = (values) => {
        console.log(values)
        const formData = new FormData();
        let ticket_type = options.find((it => it.label === values.motivo))
        ticket_type = ticket_type.key || ''
        formData.append('files', file);
        formData.append('ticket_type', ticket_type);
        formData.append('message', values.descricao);
        formData.append('order_uuid', uuid);
        formData.append('products_uuid', JSON.stringify(values.checked));

        api_direct.post(`/api/support-register-ticket`,formData,config)
        .then(response => { 
            return notify('Ticket registrado com sucesso!', 'success')
        })
        .catch(error => {
            notify('Erro ao tentar registar ticket', 'error')
        })
    }


    useEffect(() => {
        const fetchData = async () => {
            getListTicketOptions()
            getOrderItens()
        }
        fetchData()
    }, [customerUuid])


    return (
      <>
        <Container className="wl-page">
          <Modal show={show} onHide={handleClose} className="modal-center">
            <Modal.Header closeButton>
              <Modal.Title>Selecione o motivo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {options.map((option, index) => (
                <Form.Check
                  key={option.id}
                  value={option.label}
                  label={option.label}
                  className="mb-3"
                  type="radio"
                  id={index}
                  name="group1"
                  onChange={handleSelect}
                  checked={selectedOption === option.label}
                />
              ))}
              <Button
                type="buttom"
                className="btn-default-wl my-3"
                onClick={handleClose}
              >
                Confirmar
              </Button>
            </Modal.Body>
          </Modal>
          <div>
            <Row className="mt-4">
              <Title className="font-wl-600 text-mlg color-text-dark">
                Como podemos te ajudar?
              </Title>

              <p className="font-wl-400 text-mlg color-text-dark mt-5">
                Qual o pedido deseja atendimento?
              </p>
              <p className="font-wl-600 text-mlg color-text-dark m-0">
                Pedido {getFirstNumbersOrder(uuid)}
              </p>

              <Formik
                onSubmit={(values, { setSubmitting }) => {
                  setLoading(true);
                  setTimeout(() => {
                    handleSupportOpenTicket(values)
                    setSubmitting(false);
                    setLoading(false);
                  }, 3000);
                }}
                initialValues={{
                  telefone: "",
                  checked: [],
                  motivo: "",
                  descricao: "",
                  anexo: "",
                }}
                enableReinitialize={false}
              >
                {({
                  values,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  isValid,
                  dirty,
                }) => (
                  <FormFormik className="mt-5" onSubmit={handleSubmit}>
                    <Form.Group className="mb-5" controlId="FormUser.telefone">
                      <Form.Label className="font-wl-600 text-mlg color-text-dark">
                        Telefone de Contato
                      </Form.Label>
                      <TextField
                        name="telefone"
                        className="w-100"
                        value={values.telefone}
                        variant="standard"
                        onChange={handleChange}
                      />
                    </Form.Group>

                    <Form.Group className="mb-5" controlId="FormUser.produtos">
                      <Form.Label className="font-wl-600 text-mlg color-text-dark">
                        Qual produto deseja atendimento?
                      </Form.Label>
                      <div role="group" aria-labelledby="checkbox-group">
                        {items.map((item, index) => (
                          <label
                            className="d-flex flex-row group-checkbox-wl gap-2"
                            key={index}
                          >
                            <Field
                              className="form-check-input"
                              type="checkbox"
                              name="checked"
                              value={item.uuid}
                            />
                            <SubProductItem className="font-wl-400 color-wl text-lg">
                              {item?.product}
                            </SubProductItem>
                          </label>
                        ))}
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-5" controlId="FormUser.motivo">
                      <Form.Label className="font-wl-600 text-mlg color-text-dark">
                        Motivo
                      </Form.Label>
                      <TextField
                        id="motivo"
                        select
                        label="Selecione o motivo"
                        variant="standard"
                        fullWidth
                        onClick={handleSelect}
                        onFocus={handleChange}
                        value={selectedOption}
                        SelectProps={{
                          native: true,
                        }}
                      >
                        {options
                          .filter((opt) => opt.label == selectedOption)
                          .map((option, index) => (
                            <option key={option.id} value={option.label}>
                              {option.label}
                            </option>
                          ))}
                      </TextField>
                    </Form.Group>
                    <Form.Group className="mb-5" controlId="FormUser.descricao">
                      <Form.Label className="font-wl-600 text-mlg color-text-dark">
                        Descrição da Solicitação
                      </Form.Label>
                      <TextField
                        name="descricao"
                        fullWidth
                        value={values.descricao}
                        placeholder="Descreva o motivo"
                        variant="standard"
                        onChange={handleChange}
                      />
                    </Form.Group>
                    <Form.Group className="mb-5" controlId="FormUser.anexo">
                      <Form.Label className="font-wl-600 text-mlg color-text-dark">
                        Anexo
                      </Form.Label>
                      {/* input file with camera icon */}
                      <div className="d-flex flex-row align-items-center justify-content-between">
                        <div className="d-flex flex-row align-items-center w-100">
                          <input
                            accept="image/jpeg, image/png"
                            name="anexo"
                            type="file"
                            onChange={(e) => setFile(e.target.files[0])}
                            value={values.anexo}
                          />
                          <label htmlFor="icon-button-file">
                            <IconButton
                              color="primary"
                              aria-label="upload picture"
                              component="span"
                            >
                              <AiOutlineCamera />
                            </IconButton>
                          </label>
                        </div>
                      </div>
                    </Form.Group>
                    <Form.Group className="mb-5" controlId="FormUser.info">
                      <Form.Label className="font-wl-600 text-mlg color-text-dark">
                        Informações Importantes
                      </Form.Label>

                      <Accordion sx={{ boxShadow: 0 }} className="accordion">
                        <AccordionSummary
                          expandIcon={<HiOutlineChevronDown size={20} />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          className="p-0"
                        >
                          <span className="text-mg font-wl-600 color-text-dark">
                            Falar sobre a entrega
                          </span>
                        </AccordionSummary>
                        <AccordionDetails className="pt-0 subcategories">
                          <li className="list-unstyled text-mg font-wl-600 color-text-dark">
                            <aside className="font-wl-400">
                              Caso seu pedido ainda esteja dentro do prazo de
                              entrega informado na compra e no e-mail de
                              confirmação, por gentileza aguardar. Alteração de
                              endereço não é permitido. Caso seja sua
                              solicitação, deverá prosseguir com o cancelamento.
                            </aside>
                          </li>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion sx={{ boxShadow: 0 }} className="accordion">
                        <AccordionSummary
                          expandIcon={<HiOutlineChevronDown size={20} />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          className="p-0"
                        >
                          <span className="text-mg font-wl-600 color-text-dark">
                            Troca
                          </span>
                        </AccordionSummary>
                        <AccordionDetails className="pt-0 subcategories">
                          <li className="list-unstyled text-mg font-wl-600 color-text-dark">
                            <aside className="font-wl-400">
                              O prazo dessa solicitação é de até 07 dias
                              corridos a partir da data da entrega. Caso a
                              solicitação seja realizada fora desse prazo, não
                              poderá ser atendida. Os parceiros não realizam
                              trocas de modelo ou voltagem dos produtos. Em caso
                              de produto com avaria ou defeito estético, favor
                              anexar imagens do produto, da Nota Fiscal recebida
                              e da embalagem com a etiqueta em nome do
                              destinatário.
                            </aside>
                          </li>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion sx={{ boxShadow: 0 }} className="accordion">
                        <AccordionSummary
                          expandIcon={<HiOutlineChevronDown size={20} />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          className="p-0"
                        >
                          <span className="text-mg font-wl-600 color-text-dark">
                            Cancelamento
                          </span>
                        </AccordionSummary>
                        <AccordionDetails className="pt-0 subcategories">
                          <li className="list-unstyled text-mg font-wl-600 color-text-dark">
                            <aside className="font-wl-400">
                              O prazo dessa solicitação é de até 07 dias
                              corridos a partir da data da entrega. Caso a
                              solicitação seja realizada fora desse prazo, não
                              poderá ser atendida. Em caso de produto com
                              avaria, favor anexar imagens do produto, da Nota
                              Fiscal recebida e da embalagem com a etiqueta em
                              nome do destinatário.
                            </aside>
                          </li>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion sx={{ boxShadow: 0 }} className="accordion">
                        <AccordionSummary
                          expandIcon={<HiOutlineChevronDown size={20} />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          className="p-0"
                        >
                          <span className="text-mg font-wl-600 color-text-dark">
                            Informações sobre pagamento
                          </span>
                        </AccordionSummary>
                        <AccordionDetails className="pt-0 subcategories">
                          <li className="list-unstyled text-mg font-wl-600 color-text-dark">
                            <aside className="font-wl-400">
                              Não é possível alterações na forma de pagamento
                              após conclusão do pedido. Caso seja sua
                              solicitação, deverá prosseguir com o cancelamento.
                            </aside>
                          </li>
                        </AccordionDetails>
                      </Accordion>
                    </Form.Group>
                    <Line />
                    <Footer className="d-flex justify-content-center align-items-center bg-white my-5">
                      <Button type="submit" className="btn btn-default-wl">
                        Enviar
                      </Button>
                    </Footer>
                  </FormFormik>
                )}
              </Formik>
            </Row>
          </div>
        </Container>
        {Loading && <LoaderSmall />}
      </>
    );
}
